import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { ProductEntity, ProductRequestEntity } from 'src/entities/ProductEntity';
import requestUtil from 'src/utils/request.util';

import { useProjectCache } from './usePlanningsCache';

export const useMutationProduct = () => {
  const queryClient = useQueryClient();
  const productCache = useProjectCache();

  return {
    addProduct: useMutation(
      (product: ProductRequestEntity) => axios.post('/api/v2/products', requestUtil.convertKeysToSnakeCase(product)),
      {
        onSuccess: () => queryClient.invalidateQueries(['products']),
      }
    ),
    updateProduct: useMutation(
      (product: ProductEntity) => axios.put(`/api/v2/products/${product.id}`, requestUtil.convertKeysToSnakeCase(product)),
      {
        onSuccess: (res: { data: ProductEntity }) => {
          productCache.update(res.data);
        },
      }
    ),
    deleteProducts: useMutation(
      (ids: number[]) => axios.delete('/api/v2/products/bulk', { data: { ids } }),
      {
        onSuccess: () => {
          // eslint-disable-next-line no-void
          void queryClient.invalidateQueries(['products']);
        },
      }
    ),
  };
};
